import { Badge, Card, CardBody, HStack, Icon, Text, Textarea, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { FaInfoCircle, FaStickyNote } from "react-icons/fa";

export default function QuickExplanationField({
  filters,
  handleApplyFilters,
  isRTL,
  t,
}) {
  const [localValue, setLocalValue] = useState(filters.quickExplanation);

  return (
    <Card bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="md" boxShadow="sm" mt={1}>
      <CardBody p={2}>
        <VStack spacing={1} align="stretch">
          <HStack justify="space-between" align="center">
            <HStack spacing={1}>
              <Icon as={FaStickyNote} color="gray.600" />
              <Text fontSize="xs" fontWeight="semibold" color="gray.700">
                {t("reports.quickExplanation", "شرح سريع للتقرير")}
              </Text>
            </HStack>
            <Badge colorScheme="gray" variant="subtle" fontSize="xs">
              {t("reports.optional", "اختياري")}
            </Badge>
          </HStack>
          <Text fontSize="xs" color="gray.600">
            {t("reports.quickExplanationDesc", "ملاحظات مختصرة أو شرح سريع للسياق (سيتم ترجمته تلقائيًا)")}
          </Text>
          <Textarea
            value={localValue}
            onChange={(event) => setLocalValue(event.target.value)}
            onBlur={() => handleApplyFilters({ quickExplanation: localValue })}
            placeholder={t("reports.quickExplanationPlaceholder", "أدخل شرحًا سريعًا للتقرير...")}
            size="sm"
            minH="20px"
            resize="vertical"
            textAlign={isRTL ? "right" : "left"}
            dir={isRTL ? "rtl" : "ltr"}
          />
          <HStack spacing={1} fontSize="xs" color="gray.500">
            <Icon as={FaInfoCircle} />
            <Text>{t("reports.autoTranslated", "سيتم ترجمة هذا الشرح تلقائيًا عند عرض التقرير")}</Text>
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
}
